const useOverridesTaskExtraFields = (name, values, params) => {
  const extraParams = { ...params };

  if (name === 'Policy Overrides' || name === 'Offer Overrides') {
    switch (values.overrideAction) {
      case 'Override Branded Title':
        extraParams.VIN = {
          type: 'shorttext',
          name: 'VIN (Optional)'
        };
        extraParams.allowBrandedTitleCoverage = {
          type: 'boolean',
          name: 'Allow adding coverages (Optional)'
        };
        break;
      case 'Override MSRP Too High':
        extraParams.VIN = {
          type: 'shorttext',
          name: 'VIN (Optional)'
        };
        break;
      case 'Override Excluded VIN':
        extraParams.VIN = {
          type: 'shorttext',
          name: 'VIN (Optional)'
        };
        break;
    }
  }

  return extraParams;
};
export default useOverridesTaskExtraFields;
